import { render, staticRenderFns } from "./BillingProfile.vue?vue&type=template&id=896004b2&scoped=true&lang=html"
import script from "./BillingProfile.vue?vue&type=script&lang=js"
export * from "./BillingProfile.vue?vue&type=script&lang=js"
import style0 from "./BillingProfile.vue?vue&type=style&index=0&id=896004b2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "896004b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/html/untrrv2/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('896004b2')) {
      api.createRecord('896004b2', component.options)
    } else {
      api.reload('896004b2', component.options)
    }
    module.hot.accept("./BillingProfile.vue?vue&type=template&id=896004b2&scoped=true&lang=html", function () {
      api.rerender('896004b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/snippets/BillingProfile.vue"
export default component.exports